import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

import { Job} from '../../models/job';
import { Store } from '@ngrx/store';
import { AppState,selectReportState } from '@app/store/app.states';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { ReportActionTypes, GenerateJobReport, GeneratePageReport } from '@app/store/actions/report.actions';
import { ReportTypes } from '../../models/report';
import { DocumentSegment } from '../../models/documentSegment';
// import { listTransition } from '@app/core/animations/list-animations';

@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss']
})
export class ReportDialogComponent implements OnInit {

//  dialogFormGroup: FormGroup;
  success:boolean = false;
  complete:boolean = false; // for the svg pen display

  includeAdditonalInfo:boolean = true;

  //@ViewChild('notifyForm') notifyForm;
  jobs:Job[];
  selectedJob:Job;
  selectedDocumentSegment:DocumentSegment;

  reportType:string = ReportTypes.PAGE_POSITION;
  reportTypes:any = ReportTypes;

  colReport: { selectedJobPages: any, allJobs: any }[] = [];

  constructor(
    public dialogRef: MatDialogRef<ReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    private fb: FormBuilder,
    private store: Store<AppState>

  ) {

    this.jobs = data.jobs;
    this.selectedJob = data.job;
    this.selectedDocumentSegment = data.documentSegment?data.documentSegment:null;
  }

  ngOnInit() {
    if(!this.selectedJob){

      this.jobs.map(allJobs => {
        allJobs.documentSegments.map(jobPages => {
          if(this.selectedDocumentSegment.segmentNumber === jobPages.segmentNumber) {
            allJobs.campaignRegions.map(jobPagesCampaigns => {
              this.colReport.push({ selectedJobPages: jobPages, allJobs: jobPagesCampaigns});
            });
          }
        });
      });

    }
  }

  onSubmit(){

    let dsUUID = [];
    if(!this.selectedJob){
      for(let job of this.jobs){
        for(let docs of job.documentSegments){
          if (this.selectedDocumentSegment.segmentNumber === docs.segmentNumber) {
            let pagesUUID = docs.uuid;
            dsUUID.push(pagesUUID);
          }
        }
      }
    }

    let joinUUID = dsUUID.join();

    this.success = true;
    let job = new Job();

    if(this.selectedJob) {
      job.uuid = this.selectedJob.uuid;
    }

    let ds = new DocumentSegment();
    if(this.selectedDocumentSegment && this.selectedJob)
      ds.uuid = this.selectedDocumentSegment.uuid;

    if(!this.selectedJob){
      ds.uuid = joinUUID;
    }
    const payload = {job:job,type:this.reportType,documentSegment:ds,addInfo:this.includeAdditonalInfo};

    // if this is a page report
    if(this.selectedDocumentSegment){
      this.store.dispatch(new GeneratePageReport(payload));
    }else{
      this.store.dispatch(new GenerateJobReport(payload));
    }


    setTimeout(val => this.complete = true,500);
  }

  close():void{

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/report-dialog/report-dialog.component.ts